export const BASIC_OBJECT_CATEGORIES = [
  { key: 'parking', label: '주차구역' },
  { key: 'emergency', label: '비상벨' },
  { key: 'cctv', label: 'CCTV' },
  { key: 'pillar', label: '기둥' },
] as const

type BasicObjectCategory = (typeof BASIC_OBJECT_CATEGORIES)[number]['key']

export function basicObjectCategory(type: string): BasicObjectCategory | null {
  if (type.startsWith('p-parking')) return 'parking'
  if (type === 'p-emergency') return 'emergency'
  if (['p-cctv', 'p-light-cctv', 'p-warning-cctv'].includes(type)) return 'cctv'
  if (type === 's-pillar') return 'pillar'
  return null
}

export function selectBasicObjectLayers(layers: readonly { name: string; suggestedType: string }[]): Set<string> {
  return new Set(layers.filter((layer) => basicObjectCategory(layer.suggestedType)).map((layer) => layer.name))
}

export function countBasicObjects(types: readonly string[]): Record<BasicObjectCategory, number> {
  const counts = { parking: 0, emergency: 0, cctv: 0, pillar: 0 }
  types.forEach((type) => {
    const category = basicObjectCategory(type)
    if (category) counts[category]++
  })
  return counts
}
